import { Action, Dispatch } from "redux";

export const UPDATE_BACKDROP = "UPDATE_BACKDROP";

interface UpdateBackdropAction extends Action
{
    type: typeof UPDATE_BACKDROP;
    show: boolean;
    zIndex?: number;
}

const updateBackdropAction = () =>
{
    return {
        type: typeof UPDATE_BACKDROP
    };
};

export const updateBackdropAsync = () => async (dispatch: Dispatch) =>
{
    dispatch(updateBackdropAction());
};

export type UIActions = UpdateBackdropAction;